import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/history';


// GETBYID
function getById(state, action) {
  state.getById.data = action.payload.data ? action.payload.data:[];
}

function conexionGetById(state, action) {
  state.getById.connection= action.payload.connection;
}

function errorGetById(state, action) {
  state.getById.error= action.payload.error ? action.payload.error:false;
  state.getById.message= action.payload.message ? action.payload.message:"";
}

function getByIdReset(state, action) {
  state.getById.data=[];
  state.getById.connection= false;
  state.getById.error= false;
  state.getById.message= "";
}

/**
 * Conexión
 */
const historyReducer = createSlice({
  name: 'history',
  initialState: initState,
  reducers: {
    // GETBYID
    getById,
    conexionGetById,
    errorGetById,
    getByIdReset,
  },
});

export const historyActions = {
  ...historyReducer.actions,
};

export default historyReducer.reducer;
